export default "__VITE_ASSET__1nKppR0l__"